import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDocumentService } from '../../services/dynamic-document.service';
import { Trame } from '../../entities/trame';
import { map } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../dialogs/dialog.component';
import { CommonService } from 'src-adisco/services/common.service';
import { DatePipe } from '@angular/common';
import { EmailService } from '../../services/email.service';
import { FrameValidation, Trame2Validate } from '../frame-import/frame-import.component';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-frame-validation',
  templateUrl: './frame-validation.component.html',
  styleUrls: ['./frame-validation.component.css']
})
export class FrameValidationComponent implements OnInit, OnDestroy {
  private documentName = 'dynamic_workflow_product';
  private sideBar: boolean = true;
  frames: Trame[] = [];
  sortedFrames: any[] = [];
  currentSort = { column: '', direction: 'asc' };
  displayedColumns: string[] = ['submissionDate', 'supplier', 'frameType', 'status'];
  selectedFrame: Trame;
  statusList: any[] = [];

  frameValidation: FrameValidation;

  importStats = {
    totalLines: 0,
    ignoredLines: 0,
    validLines: 0,
    alertLines: 0,
    errorLines: 0,
    nbDepublie:0,
    articlesWithoutTarifsInDatabase:[]
  }; // Données de statistiques
  reportDetails: string = ''; // Rapport détaillé ligne par ligne

  searchInput: string = '';

  get needValidation() {
    return this.selectedFrame.status.value == 'A_VALIDER';
  }

  constructor(private dynamicDocumentService: DynamicDocumentService,
    private datePipe: DatePipe,
    private emailService: EmailService,
    private router: Router,
    private dialog: MatDialog,
    private commonService: CommonService) {
      window.addEventListener('storage', (event: StorageEvent) => {
        if (event.key === 'token' && event.newValue === null) {
          this.router.navigate(['/login']); 
        }
      });
    }

  ngOnInit(): void {
    this.hideSearchBar();
    this.setHeaderBloc();
    this.loadFrames();
    this.loadStatus();
  }

  hideSearchBar() {
    let sideBarElement = document.getElementsByClassName('wrap-search-bar')[0];
    this.sideBar && sideBarElement ? sideBarElement.classList.add('hide-element') : (sideBarElement ? sideBarElement.classList.remove('hide-element') : null);
    this.sideBar = !this.sideBar;
  }

  setHeaderBloc() {
    let header = document.getElementById('header');
    let headerBloc = document.getElementById('header-bloc');
    if (headerBloc && header) {
      headerBloc.style.height = header.clientHeight.toString() + 'px';
      headerBloc.style.width = '10px';
    }
  }

  loadStatus() {
    this.commonService.getStatutWorkflow().pipe(
      map((res) => {
        this.statusList = res;
      })
    ).subscribe();
  }

  loadFrames() {
    this.dynamicDocumentService.find(
      {
        collectionName: this.documentName,
        filters: [],
        sorts: {},
        page: 1,
        pageSize: 999999
      }, true
    ).pipe(
      map((res) => {
        this.frames = res.content;
        this.sortedFrames = [...this.frames];
        this.sortBy('submissionDate');
        this.sortBy('submissionDate');
        this.selectFrame(this.sortedFrames[0]);
      })
    ).subscribe();
  }

  searchFrames(event: any) {
    let val = event.target.value.toLowerCase();
    
    this.sortedFrames = this.frames?.filter(frame => {
      return Object.values(frame)?.some(value => {
        const dateValue = new Date(value);
        if (!isNaN(dateValue.getTime())) {
          if (dateValue.toLocaleString().includes(val)) {
            return true;
          }
        }

        if (value?.value?.toString()?.toLowerCase()?.includes(val)) {
          return true;
        }

        if (value?.labels?.fr_FR?.toString()?.toLowerCase()?.includes(val)) {
          return true;
        }

        return value?.toString()?.toLowerCase()?.includes(val);
      });
    });

    this.selectFrame(this.sortedFrames[0]);
  }  

  selectFrame(frame: any): void {
    this.selectedFrame = frame;
    let docSupplier: any = this.selectedFrame.supplier;
    let docId: string = docSupplier.documentId;
    let frame2validate: Trame2Validate = {
      frameRepository: this.selectedFrame.frameRepository ? this.selectedFrame.frameRepository : '',
      frameType:  this.selectedFrame.frameType,
      supplier: { documentName: 'dynamic_legal_entity', documentId: docId },
      trameName: this.selectedFrame.frameName ? this.selectedFrame.frameName : ''
    };
    this.getRecord(frame2validate);
  }

  getRecord(frameToValidate: Trame2Validate) {
    this.dynamicDocumentService.validateFrame(frameToValidate).subscribe((res) => {
      this.frameValidation = res;
  
      this.importStats.totalLines = res.nbLignesTreated;
      this.importStats.ignoredLines = res.nbLignesIgnore;
      this.importStats.validLines = res.nbLignesOk;
      this.importStats.alertLines = res.nbLignesWarn;
      this.importStats.errorLines = res.nbLignesError;
      this.importStats.nbDepublie = res.numberDepublished;
      this.importStats.articlesWithoutTarifsInDatabase = res.articlesWithoutTarifsInDatabase;
  
      let report = document.getElementById('report-bloc');
      if (report) {
        const safeReport = report;
        safeReport.innerHTML = ''; // Clear previous report content
  
        // Iterate through records and add them to the report
        if (res.records && Array.isArray(res.records)) {
          res.records.forEach(record => {
            if (record && record.type !== 'SUCCESS' && record.row && record.message) {
              const node = document.createElement('div');
              node.classList.add(record.type.toLowerCase());
              node.classList.add(record.type === 'WARNING' ? 'text-warning' : (record.type === 'ERROR' ? 'text-danger' : ''));
              node.innerText = `${record.row} - ${record.type} [${record.sheetname}${record.column ? ', colonne ' + record.column : ''}] ${record.message}\n`
            
              safeReport.appendChild(node);
            }
          });
        }
  
        // Additional log entries for articles without tariffs
        if (this.importStats?.articlesWithoutTarifsInDatabase?.length) {
          this.importStats.articlesWithoutTarifsInDatabase.forEach(article => {
            const node = document.createElement('div');
            node.classList.add('text-danger');
            node.innerText = `L'article ${article} n'a pas de tarif.`;
            safeReport.appendChild(node);
          });
        }
      }
    });
  }
  

  // getRecord(frameToValidate: Trame2Validate) {
  //   this.dynamicDocumentService.validateFrame(frameToValidate).subscribe((res) => {
  //     this.frameValidation = res;

  //     this.importStats.totalLines = res.nbLignesTreated;
  //     this.importStats.ignoredLines = res.nbLignesIgnore;
  //     this.importStats.validLines = res.nbLignesOk;
  //     this.importStats.alertLines = res.nbLignesWarn;
  //     this.importStats.errorLines = res.nbLignesError;
  //     this.importStats.nbDepublie = res.numberDepublished
  //     this.importStats.articlesWithoutTarifsInDatabase = res.articlesWithoutTarifsInDatabase

  //     let report = document.getElementById('report-bloc');
  //     if (report) {
  //       report.innerHTML = '';
  //       res.records.forEach(record => {
  //         if (record && record.type !== 'SUCCESS' && record.row && record.message) {
  //           const node = document.createElement('div');
  //           node.classList.add(record.type.toLowerCase());
  //           node.classList.add(record.type == 'WARNING' ? 'text-warning' : (record.type == 'ERROR' ? 'text-danger' : ''));
  //           node.innerText = `${record.row} - ${record.type} [${record.sheetname}${record.column ? ', colonne ' + record.column : ''}] ${record.message}\n`;
  //           if (report) report.appendChild(node);
  //         }
  //       })
  //         // ADDITIONAL log entries for articles without tariffs
  // if (this.importStats?.articlesWithoutTarifsInDatabase?.length) {
  //   this.importStats.articlesWithoutTarifsInDatabase.forEach(article => {
  //     const node = document.createElement('div');
  //     node.classList.add('text-danger');
  //     node.innerText = `L'article ${article} n'a pas de tarif.`;
  //     report.appendChild(node);
  //   });
  // }
  //     }
      

  //   })
  // }

  sortBy(column: string): void {
    if (this.currentSort.column === column) {
      this.currentSort.direction = this.currentSort.direction === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSort.column = column;
      this.currentSort.direction = 'asc';
    }

    const keys = column.split('.');
    this.sortedFrames.sort((a, b) => {
      let valA = a, valB = b;
      keys.forEach(key => {
        valA = valA?.[key];
        valB = valB?.[key];
      });

      const comparison = valA > valB ? 1 : valA < valB ? -1 : 0;
      return this.currentSort.direction === 'asc' ? comparison : -comparison;
    });
  }

  downloadReport() {
    const content = this.formatFrameValidation(this.frameValidation);

    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `rapport-${this.selectedFrame?.frameName?.split('.')[0]}.txt`;

    link.click();

    URL.revokeObjectURL(link.href);
  }
  //testing
  private formatFrameValidation(frame: FrameValidation): string {
    let formatted = `Fournisseur : ${this.selectedFrame.supplier?.value || 'Fournisseur inconnu'}\n`;
    formatted += `Trame ${(this.selectedFrame.frameType?.value?.includes('roduit') || this.selectedFrame.frameType == 'Produit') ? 'Produit' : 'Tarif'}\n`;
    let date: any = this.selectedFrame.submissionDate;
    formatted += `Date : ${new Date(date).toISOString()}\n\n`;
  
    formatted += `Nombre de lignes traitées: ${frame.nbLignesTreated}\n`;
    formatted += `Nombre de lignes valides : ${frame.nbLignesOk}\n`;
    formatted += `Nombre d'articles dépubliés : ${frame.numberDepublished}\n`;
    formatted += `Nombre de lignes en erreur : ${frame.nbLignesError}\n`;
    formatted += `Nombre de lignes en alertes : ${frame.nbLignesWarn}\n\n`;
    formatted += frame.articlesWithoutTarifsInDatabase
    .map(article => `L'article ${article} n'a pas de tarif.`)
    .join('\n') + '\n\n';
  
  
    const groupedBySheet = new Map<string, any[]>();
  
    frame.records.forEach((record) => {
      if (record && record.type !== 'SUCCESS' && record.row) {
        if (!groupedBySheet.has(record.sheetname)) {
          groupedBySheet.set(record.sheetname, []);
        }
        groupedBySheet.get(record.sheetname)!.push(record);
      }
    });
  
    groupedBySheet.forEach((records, sheetname) => {
      formatted += `Feuille: ${sheetname}\n`;
      records.forEach(record => {
        formatted += `${record.row} - ${record.type} [${record.sheetname}${record.column ? ', colonne ' + record.column : ''}] ${record.message}\n`;
      });
      formatted += `\n`; // Adding space between sheets
    });

    formatted += frame.articlesWithoutTarifsInDatabase
    .map(article => `L'article ${article} n'a pas de tarif.`)
    .join('\n') + '\n\n';
  
  
    return formatted;
  }
  

  // private formatFrameValidation(frame: FrameValidation): string {
  //   let formatted = `Fournisseur : ${this.selectedFrame.supplier?.value || 'Fournisseur inconnu'}\n`;
  //   formatted += `Trame ${(this.selectedFrame.frameType?.value?.includes('roduit') || this.selectedFrame.frameType == 'Produit') ? 'Produit' : 'Tarif'}\n`;
  //   let date: any = this.selectedFrame.submissionDate;
  //   formatted += `Date : ${new Date(date).toISOString()}\n\n`;

  //   formatted += `Nombre de lignes traitées: ${frame.nbLignesTreated}\n`;
  //   formatted += `Nombre de lignes valides : ${frame.nbLignesOk}\n`;
  //   formatted += `Nombre d'articles dépubliés : ${frame.numberDepublished}\n`;
  //   formatted += `Nombre de lignes en erreur : ${frame.nbLignesError}\n`;
  //   formatted += `Nombre de lignes en alertes : ${frame.nbLignesWarn}\n\n`;

  //   frame.records.forEach((record) => {
  //     if (record && record.type !== 'SUCCESS' && record.row && record.message) {
  //       formatted += `${record.row} - ${record.type} [${record.sheetname}${record.column ? ', colonne ' + record.column : ''}] ${record.message}\n`
  //     }
  //   });

  //   return formatted;
  // }

  refuse() {
    let dialogRef = this.dialog.open(DialogComponent,
      {
        data: {
          title: `Refus d'une trame`,
          message: `Vous êtes sur le point de refuser la publication de la trame. Un email sera envoyé au fournisseur avec le refus mentionné ci-dessous :`,
          confirmText: `Refuser la trame`,
          cancelText: `Annuler`,
          frame: true,
          field: 'textarea'
        },
        maxWidth: '540px'
      });

    dialogRef.afterClosed().subscribe((response) => {
     
      if (response) {
        this.selectedFrame.status = { parameterId: this.statusList.find(el => el.valeur == 'REFUSE')?.id }
        this.formatDates(this.selectedFrame);
        this.dynamicDocumentService.saveDocument(this.documentName,
          this.selectedFrame, true
        ).pipe(
          map(() => {
            this.sendEmailToSupplier(response);
            this.ngOnInit();
          })
        ).subscribe();
      }
    })
  }

  sendEmailToSupplier(dateOrReason: string | Date) {
    let doc: any = this.selectedFrame.supplier;
    let userImporterEmail = this.selectedFrame.userImported
    let docId = doc.documentId;
    this.dynamicDocumentService.findById('dynamic_legal_entity', docId, true
    ).pipe(
      map((res) => {
        let mailTo =environment.tramValidationMailList+userImporterEmail;
      
        if (typeof dateOrReason == 'string') {

          this.emailService.sendFrameRefused(mailTo, this.selectedFrame, dateOrReason).subscribe();
        } else {
          this.emailService.sendFrameAccepted(mailTo, this.selectedFrame, dateOrReason).subscribe();
        }
      })
    ).subscribe();
  }

  submit() {
    let dialogRef = this.dialog.open(DialogComponent, {
      data: {
        title: `Valider une trame`,
        message: `Choisissez une date de publication de la trame. Un email sera envoyé au fournisseur une fois la publication terminée`,
        confirmText: `Valider la trame`,
        cancelText: `Annuler`,
        frame: true,
        field: 'date',
        dateValue: this.selectedFrame.publicationDate
      },
      maxWidth: '540px'
    });

    dialogRef.afterClosed().subscribe((response) => {
    
      if (response) {
        this.selectedFrame.publicationDate = response;
        this.selectedFrame.status = { parameterId: this.statusList.find(el => el.valeur == 'VALIDE')?.id }
        this.formatDates(this.selectedFrame);
        this.dynamicDocumentService.saveDocument(this.documentName,
          this.selectedFrame, true
        ).pipe(
          map(() => {
            this.sendEmailToSupplier(response);
            this.ngOnInit();
          })
        ).subscribe();
      }
    })
  }

  formatDates(frame: Trame) {
    frame.submissionDate = this.datePipe.transform(
      frame.submissionDate,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
    frame.creationDate = this.datePipe.transform(
      frame.creationDate,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
    frame.updatingDate = this.datePipe.transform(
      frame.updatingDate,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
    frame.publicationDate = this.datePipe.transform(
      frame.publicationDate,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
  }

  ngOnDestroy(): void {
    this.hideSearchBar();
  }

}
